import { render, staticRenderFns } from "./SbAttachPackModal.vue?vue&type=template&id=09cd5472"
import script from "./SbAttachPackModal.vue?vue&type=script&lang=js"
export * from "./SbAttachPackModal.vue?vue&type=script&lang=js"
import style0 from "./SbAttachPackModal.vue?vue&type=style&index=0&id=09cd5472&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports